import { createApi } from '@reduxjs/toolkit/query/react';

import fetchBaseQuery from '@app/api/fetchBaseQuery';
import type { GetWorkflowStepDynamicDataRequest, StepDynamicDataResponse } from '@lokalise/types';
import { constructUrl } from '../utils';

const workflowsApi = createApi({
    reducerPath: 'workflows',
    baseQuery: fetchBaseQuery(),

    endpoints: (builder) => ({
        getDynamicData: builder.query<StepDynamicDataResponse, GetWorkflowStepDynamicDataRequest>({
            query: ({ projectId, stepType, ...params }) => ({
                method: 'GET',
                url: constructUrl(`/workflows/projects/${projectId}/step-configuration/${stepType}/`, { ...params }),
            }),
            // Stop dynamic data caching
            keepUnusedDataFor: 0,
            transformResponse: ({ data }: { data: StepDynamicDataResponse }) => data,
        }),
    }),
});

export const { useGetDynamicDataQuery } = workflowsApi;

export default workflowsApi;
